import { SET_NAV_COLOR, SHOW_NAV, HIDE_NAV, SET_NAV_SOLID } from '../../actions'

const initialState = {
  color: '#fff',
  open: false,
  solid: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_NAV_COLOR:
      return {
        ...state,
        color: action.payload
      }
    case SHOW_NAV:
      return {
        ...state,
        open: true
      }
    case HIDE_NAV:
      return {
        ...state,
        open: false
      }
    case SET_NAV_SOLID:
      return {
        ...state,
        solid: action.payload
      }
    default:
      return state
  }
}

export const setColor = (color) => ({
  type: SET_NAV_COLOR,
  payload: color
})

export const setSolid = (solid) => ({
  type: SET_NAV_SOLID,
  payload: solid
})

export const close = () => ({
  type: HIDE_NAV
})

export const toggle = () => (dispatch, getState) => dispatch({
  type: getState().navigation.open ? HIDE_NAV : SHOW_NAV
})



// WEBPACK FOOTER //
// ./src/redux/modules/navigation/index.js